// Style
import "../../styles/menu/MenuStyle.scss";
// Components
import IntroNoOrder from "./IntroNoOrder";
import MenuMain from "./MenuMain";
// Recoil
import { useRecoilValue } from "recoil";
import { tableState } from "../../atom/menu";

// 브이디메뉴 메인화면
function OrderMain() {
  // **기능정의**
  // [isTable 값으로 테이블 상태 구분 / isTable값은 전역으로 관리됨]
  // *테이블이 있는경우(order내역이있는경우)
  //  : 메뉴 화면으로 이동
  // *테이블이 없는경우(order내역이없는경우)
  //  : 인원 선택 화면으로 이동
  const isTable = useRecoilValue(tableState);

  return <>{isTable.adult > 0 ? <MenuMain /> : <IntroNoOrder />}</>;
}
export default OrderMain;
